import styled from 'styled-components';

export const SectionButtonContainer = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.xSmallExtraBold}
  margin-left: 18px;
  margin-right: 18px;
  width: 55px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.textPrimary};
  opacity: ${({ active }) => (active ? 1 : 0.2)};
  pointer-events: ${({ active }) => (active ? 'all' : 'none')};
`;

export const SectionButton = styled.button`
  min-width: 52px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  ${({ theme }) => theme.fontFamily.mainFont.xSmallExtraBold}
  background: none;
  color: ${({ theme }) => theme.colors.textPrimary};
`;
